<template>
  <div>
    <div v-if="!currentTestResult" class="tab">
      <loader v-if="isLoadingQuestions.questions || isLoadingProgress"></loader>

      <template v-else>
        <div class="tab__header">
          <router-link to="/pdd/themes" class="come-back">Назад к списку тем</router-link>
          <div class="h2 tab__title">{{ themeName }}</div>
        </div>

        <div class="tab__question">
          <div class="sly-wrap">
            <div ref="questions-slider" class="sly">
              <div class="slider-number">
                <div
                  v-for="(question, index) of questions"
                  :class="getQuestionClass(index)"
                  :key="index"
                  class="slider-number__item"
                  @click="goToQuestion(index)"
                >{{ index + 1 }}</div>
              </div>
            </div>

            <div class="sly-arrow"></div>
          </div>

          <div class="ticket-question__image">
            <img v-if="currentQuestion.image" :src="`${$APP_URL}/storage/${currentQuestion.image}`" class="mb-3 w-100"/>
          </div>

          <div class="ticket-question">
            <div class="ticket-number">Вопрос {{ currentQuestionIndex + 1 }}</div>
            <div class="h3" v-html="currentQuestion.text"></div>
          </div>

          <form>
            <div
              v-for="(answer, key, index) in getAnswersOfQuestion(currentQuestion)"
              :key="index"
              :class="getAnswerClass(key, currentQuestionIndex)"
              class="checkout-group"
            >
              <input @click="answerOnQuestion(key)" type="radio" name="checkout-radio" :id="index" class="checkout-group__input">
              <label :for="index" class="checkout-group__label">
                <span>{{ index + 1 }}</span>
                <div class="checkout-group__text">{{ answer }}</div>

                <div v-if="isShowComment(key)" class="answer-info">
                  <hr>
                  <div class="text" v-html="currentQuestion.comment"></div>
                </div>
              </label>
            </div>

            <button
              ref="next-button"
              @click.prevent="goToNextQuestion"
              :disabled="!isQuestionAnswered" class="btn btn-green">Далее</button>
          </form>
        </div>
      </template>
    </div>

    <div v-if="currentTestResult">
      <div class="tab">
        <div class="tab__header">
          <div class="tab__title h2">Результаты теста</div>
        </div>

        <div class="flex flex-justify-sb result result--min">
          <div class="result-item"><span><span class="green">{{ currentTestResult.right }}</span>/{{ currentTestResult.questions }}</span> правильных ответов</div>
          <div class="result-item">{{ currentTestResult.errors }} ошибок </div>
        </div>

        <div class="result-link">
          <button type="button" @click="reloadQuestions" class="btn btn-green">пройти еще раз</button>
          <share-results-form
            test-type="theme"
            :test-data="formattedCurrentTestResult"
            :pre-generated-url="preGeneratedUrl"
          />
          <router-link :to="{ path: '/pdd/themes', query: { coll: currentCollectionId }}">Перейти к списку тем</router-link>
        </div>
      </div>

      <div v-if="currentTestResult.wrong > 0" class="h3 title text-center">Ваши ошибки</div>

      <div class="wrong" v-for="question of answeredQuestions" v-if="question.answer !== question.question.correct_answer" :key="question.index">
        <div class="wrong-header">
          <div class="wrong-number">Вопрос {{ question.index }}</div>
          <div class="wrong-question" v-html="question.question.text"></div>
          <div class="wrong-btn js-wrong-btn" data-open="close">Показать</div>
        </div>

        <img v-if="question.question.image" :src="`${$APP_URL}/storage/${question.question.image}`" class="wrong-img"/>

        <div class="wrong-block">
          <div class="answer"
               v-for="(answer, key, index) in question.answers"
               :key="index"
               :class="{ 'answer-right': question.question.correct_answer === key, 'answer-wrong': key === question.answer }"
          >
            <div class="answer-header">
              <div class="answer-number">{{ index + 1 }}</div>
              <div class="answer-title">{{ answer }}</div>
            </div>

            <div class="answer-info" v-if="question.question.correct_answer === key">
              <hr>
              <div class="text" v-html="question.question.comment"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal ref="unfinished-ticket" hide-footer no-close-on-backdrop hide-header-close hide-header>
      <div class="modal-header"></div>
      <div class="h3 modal-title">Хотите продолжить решение темы?</div>
      <a @click="continueTicket" class="btn btn-green modal-btn">Продолжить</a>
      <a @click="reloadQuestions" href="#" class="modal-link">Начать заново</a>
    </b-modal>
  </div>
</template>

<script>
  import 'sly-scrolling/dist/sly';
  import { mapState, mapActions } from 'vuex';
  import mainMixin from '../../mixins/tests/main';
  import ShareResultsForm from '@/components/pdd/ShareResultsForm.vue';
  import settings from '@/settings';

  export default {
    name: 'ThemeQuestions',
    components: { ShareResultsForm },
    mixins: [mainMixin],
    data() {
      return {
        currentThemeId: parseInt(this.$route.params.id, 10),
        currentCollectionId: parseInt(this.$route.query.coll, 10),
        currentQuestionIndex: null,
        currentTestResult: null,
        answeredQuestions: [],
        answeredQuestionsForProgress: [],
        preGeneratedUrl: '',
        usedMegapolisProgress: false,
        megapolisProgressPending: false,
      };
    },
    computed: {
      ...mapState('progress', ['progress']),
      themes() {
        return this.$store.getters.themes;
      },
      questions() {
        return this.$store.getters.questions;
      },
      isLoadingProgress() {
        return this.$store.getters['progress/progressLoader'];
      },
      isLoadingQuestions() {
        return this.$store.getters.collectionsLoaders;
      },
      themeName() {
        let themeName = '';

        for (const theme of this.themes) {
          if (theme.id === this.currentThemeId) {
            themeName = theme.name;
            break;
          }
        }

        return themeName;
      },
      collectionName() {
        let collectionName = '';

        for (const theme of this.themes) {
          if (theme.id === this.currentThemeId) {
            collectionName = theme.collection_name;
            break;
          }
        }

        return collectionName;
      },
      isQuestionAnswered() {
        return !!this.getAnswerOnCurrentQuestion();
      },
      formattedCurrentTestResult() {
        if (!this.currentTestResult) return null;
        return {
          collectionId: this.currentTestResult.collectionId,
          themeId: this.currentTestResult.themeId,
          questionsCount: this.currentTestResult.questions,
          rightCount: this.currentTestResult.right,
          wrongCount: this.currentTestResult.wrong,
          errorsCount: this.currentTestResult.errors,
          answeredQuestions: this.answeredQuestions,
        };
      },
    },
    methods: {
      ...mapActions('progress', ['setProgress', 'getProgress', 'clearProgress']),
      ...mapActions('testResult', ['saveTestResult']),
      initTest() {
        this.currentQuestionIndex = this.currentQuestionIndex === null ? 0 : this.currentQuestionIndex;

        this.initSly();
      },
      getQuestionClass(index) {
        const isQuestionAnswered = !!this.getAnsweredQuestionByIndex(index);
        const isActiveQuestion = index === this.currentQuestionIndex;
        const currentAnsweredQuestion = this.getAnsweredQuestionByIndex(index);

        const isWrongAnswered = isQuestionAnswered
          ? currentAnsweredQuestion.answer !== currentAnsweredQuestion.question.correct_answer
          : false;

        const isRightAnswered = isQuestionAnswered
          ? currentAnsweredQuestion.answer === currentAnsweredQuestion.question.correct_answer
          : false;

        return {
          'active-item': isActiveQuestion,
          fail: isWrongAnswered,
          success: isRightAnswered,
        };
      },
      getAnswerClass(key) {
        const isUserAnswer = this.isQuestionAnswered && key === this.getAnswerOnCurrentQuestion().answer;
        const isCorrectAnswer = this.isQuestionAnswered && key === this.getAnswerOnCurrentQuestion().question.correct_answer;

        return {
          'answer-wrong': isUserAnswer && !isCorrectAnswer,
          'answer-right': isCorrectAnswer,
        };
      },
      isShowComment(key) {
        return this.isQuestionAnswered
          && key === this.getAnswerOnCurrentQuestion().question.correct_answer
          && this.getAnswerOnCurrentQuestion().answer !== this.getAnswerOnCurrentQuestion().question.correct_answer;
      },
      getAnswersOfQuestion(question) {
        const answers = {};

        for (const prop in question) {
          if (/^answer\d+/.test(prop) && question[prop]) {
            answers[prop] = question[prop];
          }
        }

        return answers;
      },
      async answerOnQuestion(answer) {
        const isCorrectAnswer = this.currentQuestion.correct_answer === answer;

        if (this.isQuestionAnswered) {
          return;
        }

        this.answeredQuestions.push({
          answer,
          index: this.currentQuestionIndex + 1,
          question: this.questions[this.currentQuestionIndex],
          answers: this.getAnswersOfQuestion(this.questions[this.currentQuestionIndex]),
        });

        this.answeredQuestionsForProgress.push({
          question_number: this.currentQuestionIndex + 1,
          is_correct: isCorrectAnswer,
        });

        const isLastAnswer = this.answeredQuestions.length === this.questions.length;

        const taskId = Number(settings.MEGAPOLIS_TASK_ID);
        const collId = Number(settings.MEGAPOLIS_COLLECTION_ID);

        if (settings.MEGAPOLIS_BEARER_TOKEN && settings.MEGAPOLIS_LESSON_ID && taskId === this.currentThemeId && collId === this.currentCollectionId) {
          const progressData = {
            test_url: `${settings.APP_URL}${this.$route.path}?coll=${this.$route.query.coll}`,
            lesson_id: settings.MEGAPOLIS_LESSON_ID,
            result: {
              results: this.answeredQuestionsForProgress,
            },
          };

          this.setProgress(progressData);
        }

        if (isLastAnswer && settings.MEGAPOLIS_BEARER_TOKEN && settings.MEGAPOLIS_LESSON_ID && taskId === this.currentThemeId && collId === this.currentCollectionId) {
          const saveData = {
            type: 'theme',
            category_id: this.currentCollectionId,
            theme_id: this.currentThemeId,
            payload: {
              answered_questions: this.answeredQuestions,
            },
            results: {
              questions_count: this.questions.length,
              correct_answers_count: this.answeredQuestions.filter(q => q.answer === q.question.correct_answer).length,
              wrong_answers_count: this.answeredQuestions.filter(q => q.answer !== q.question.correct_answer).length,
            },
          };

          const resp = await this.saveTestResult(saveData);
          const resultsUrl = resp && resp.uuid ? `${settings.APP_URL}/pdd/results/${resp.uuid}` : '';

          if (resultsUrl) {
            this.preGeneratedUrl = resultsUrl;

            const progressWithUrl = {
              title: `${this.themeName} (${this.collectionName})`,
              test_url: `${settings.APP_URL}${this.$route.path}?coll=${this.$route.query.coll}`,
              lesson_id: settings.MEGAPOLIS_LESSON_ID,
              result: {
                results: this.answeredQuestionsForProgress,
                results_url: resultsUrl,
              },
            };

            this.setProgress(progressWithUrl);
          }
        }

        if (isCorrectAnswer) {
          this.goToNextQuestion();
        }
      },
      showTestResult() {
        const questionsCount = this.questions.length;
        const rightsAnswers = this.answeredQuestions.filter(q => q.answer === q.question.correct_answer).length;
        const wrongAnswers = this.answeredQuestions.filter(q => q.answer !== q.question.correct_answer).length;

        this.answeredQuestions = this.answeredQuestions.sort((a, b) => a.index - b.index);
        this.currentTestResult = {
          collectionId: parseInt(this.currentCollectionId, 10),
          themeId: parseInt(this.currentThemeId, 10),
          questions: questionsCount,
          right: rightsAnswers,
          wrong: wrongAnswers,
          errors: questionsCount - rightsAnswers,
        };
        this.initResultDropdowns();
      },
      updateTestResultsSettings() {
        let hasThemeExist = false;
        const { themeResults } = this.$appSettings;

        for (let i = 0; i < themeResults.length; i++) {
          const currentTheme = themeResults[i];

          hasThemeExist = currentTheme.themeId === this.currentTestResult.themeId
            && currentTheme.collectionId === this.currentTestResult.collectionId;

          if (hasThemeExist) {
            themeResults.splice(i, 1);
            break;
          }
        }

        themeResults.push(this.currentTestResult);
        this.updateAppSettings();
      },
      goToNextQuestion() {
        if (this.isTestDone) {
          this.showTestResult();
          this.updateTestResultsSettings();

          return;
        }

        this.goToQuestion(this.getFirstUnansweredQuestionIndex(this.currentQuestionIndex));
      },
      getQuestions() {
        this.$store.dispatch('getThemeQuestions', {
          theme_id: this.currentThemeId,
          collection_id: this.currentCollectionId,
        })
          .then(async () => {
            const taskId = Number(settings.MEGAPOLIS_TASK_ID);
            const collId = Number(settings.MEGAPOLIS_COLLECTION_ID);
            if (settings.MEGAPOLIS_LESSON_ID && taskId === this.currentThemeId && collId === this.currentCollectionId) {
              await this.fillAnsweredQuestionsForProgress();
            } else {
              this.initTest();
            }
          });
      },
      async fillAnsweredQuestionsForProgress() {
        try {
          const resp = await this.getProgress({
            test_url: `${settings.APP_URL}${this.$route.path}?coll=${this.$route.query.coll}`,
            lesson_id: settings.MEGAPOLIS_LESSON_ID,
          });

          let progressData = null;

          if (resp && resp.result) {
            progressData = resp;
          } else if (this.progress && this.progress.result) {
            progressData = this.progress;
          }

          if (!progressData || !progressData.result || !Array.isArray(progressData.result.results) || !progressData.result.results.length) {
            this.initTest();
            return;
          }

          this.answeredQuestions = [];
          this.answeredQuestionsForProgress = [];

          for (const item of progressData.result.results) {
            const qNumber = Number(item.question_number);

            if (!Number.isNaN(qNumber) && qNumber >= 1) {
              const questionObj = this.questions[qNumber - 1];

              if (questionObj) {
                const userAnswer = item.is_correct ? questionObj.correct_answer : null;

                this.answeredQuestions.push({
                  answer: userAnswer,
                  index: qNumber,
                  question: questionObj,
                  answers: this.getAnswersOfQuestion(questionObj),
                });

                this.answeredQuestionsForProgress.push({
                  question_number: qNumber,
                  is_correct: !!item.is_correct,
                });
              }
            }
          }

          this.usedMegapolisProgress = true;

          const firstUnanswered = this.getFirstUnansweredQuestionIndex();
          this.currentQuestionIndex = (firstUnanswered !== null && firstUnanswered !== undefined) ? firstUnanswered : 0;

          this.initSly();

          if (this.answeredQuestions.length === this.questions.length) {
            await this.clearProgress();

            this.answeredQuestions = [];
            this.answeredQuestionsForProgress = [];
            this.preGeneratedUrl = '';
            this.usedMegapolisProgress = false;
            this.megapolisProgressPending = false;
            this.currentQuestionIndex = 0;

            this.initSly();
            this.initTest();

            return;
          }

          this.megapolisProgressPending = true;
          this.$nextTick(() => {
            if (this.$refs['unfinished-ticket']) {
              this.$refs['unfinished-ticket'].show();
            }
          });
        } catch (e) {
          this.initTest();
        }
      },
      continueTicket() {
        if (this.$refs['unfinished-ticket']) {
          this.$refs['unfinished-ticket'].hide();
        }
        this.megapolisProgressPending = false;
      },
      async reloadQuestions() {
        const taskId = Number(settings.MEGAPOLIS_TASK_ID);
        const collId = Number(settings.MEGAPOLIS_COLLECTION_ID);

        const isMegapolisUser = settings.MEGAPOLIS_LESSON_ID && taskId === this.currentThemeId && collId === this.currentCollectionId;

        if (isMegapolisUser) {
          if (this.$refs['unfinished-ticket']) {
            this.$refs['unfinished-ticket'].hide();
          }

          await this.clearProgress();

          this.currentTestResult = null;

          this.answeredQuestions = [];
          this.answeredQuestionsForProgress = [];
          this.preGeneratedUrl = '';

          this.usedMegapolisProgress = false;
          this.megapolisProgressPending = false;

          this.currentQuestionIndex = 0;

          this.initSly();
          this.initTest();

          return;
        }

        const nextR = this.$route.query.r ? parseInt(this.$route.query.r, 10) + 1 : 1;

        const query = {
          coll: this.currentCollectionId,
          r: nextR,
        };

        if (this.$route.query.lesson_id) {
          query.lesson_id = this.$route.query.lesson_id;
        }

        if (this.$route.query.megapolis_token) {
          query.megapolis_token = this.$route.query.megapolis_token;
        }

        this.$router.push({
          path: `/pdd/themes/${this.currentThemeId}`,
          query,
        });
      },
    },
    created() {
      this.getQuestions();

      if (!this.themes.length) {
        this.$store.dispatch('getCollectionThemes', this.currentCollectionId);
      }
    },
    destroyed() {
      this.clearProgress();
    },
  };
</script>

<style scoped>
.tab__title {
  padding: 0 180px;
}

@media screen and (max-width: 992px) {
  .tab__title {
    padding: 0;
  }
}
</style>
